/**
 * Opens a PDF blob in the browser's print dialog via a hidden iframe.
 * Resolves immediately after triggering the dialog so the app flow can continue.
 * The iframe stays alive until the user finishes printing.
 */
export function printPdfBlob(blob) {
  return new Promise((resolve) => {
    const url = URL.createObjectURL(blob);
    const iframe = document.createElement('iframe');
    iframe.style.position = 'fixed';
    iframe.style.right = '0';
    iframe.style.bottom = '0';
    iframe.style.width = '0';
    iframe.style.height = '0';
    iframe.style.border = 'none';
    iframe.src = url;

    let cleaned = false;
    const cleanupIframe = () => {
      if (cleaned) return;
      cleaned = true;
      try { document.body.removeChild(iframe); } catch {}
      URL.revokeObjectURL(url);
    };

    document.body.appendChild(iframe);

    iframe.onload = () => {
      try {
        iframe.contentWindow.focus();
        iframe.contentWindow.print();
      } catch {
        window.open(url, '_blank');
      }
      resolve();

      // Clean up iframe after print dialog closes
      try {
        iframe.contentWindow.addEventListener('afterprint', cleanupIframe, { once: true });
      } catch {}
      // Safety cleanup in case afterprint never fires
      setTimeout(cleanupIframe, 300000);
    };
  });
}
